module.exports = __webpack_public_path__ + "img/Daniel Márquez_Transporte.909bda19.png";